"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_bootstrap_1 = require("react-bootstrap");
const react_1 = require("react");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const mobx_react_1 = require("mobx-react");
const react_loader_1 = __importDefault(require("react-loader"));
const Defaults_1 = require("../../common/Defaults");
const hui_1 = require("@mit/hui");
const AddHoldComponent = ({ person, showCalendar, peopleStore, holds }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [show, setShow] = (0, react_1.useState)(false);
    const [reason, setReason] = (0, react_1.useState)(' ');
    const [description, setDescription] = (0, react_1.useState)('');
    const [pageError, setPageError] = (0, react_1.useState)({ error: false, errorText: '' });
    const [reasons, setReasons] = (0, react_1.useState)([{ id: ' ', text: 'Select one...' }]);
    const handleShow = () => {
        setShow(true);
    };
    const handleClose = () => {
        setShow(false);
        setReason(' ');
        setDescription('');
        setPageError({ error: false, errorText: '' });
    };
    const submitAndClose = () => {
        if (isValid()) {
            setPageError({ error: false, errorText: '' });
            setIsLoading(true);
            MedicalApi_1.default.postOnHold(person.mitId, reason, description).then((response) => {
                if (response.success) {
                    MedicalApi_1.default.fetchPersonMedicalHolds(person.mitId).then((resp) => {
                        holds.personHolds = resp.items ? resp.items : [];
                    });
                    setIsLoading(false);
                    handleClose();
                }
                else {
                    setPageError({ error: true, errorText: `An error occurred and the person could not be processed. If the problem persists, please contact ${Defaults_1.CONTACT_SUPPORT_LINK}.` });
                }
                setIsLoading(false);
            }).catch(() => {
                setIsLoading(false);
                setPageError({ error: true, errorText: `An error occurred and the person could not be processed. If the problem persists, please contact ${Defaults_1.CONTACT_SUPPORT_LINK}.` });
            });
            // medicalApi.postExemptions(person.mitId, exemptionFlags, description).then((response: PostStatusResponse) => {
            //     if (response.success) {
            //         medicalApi.fetchPersonMedicalHolds(person.mitId).then((resp) => {
            //             holds!.personHolds = resp.items ? resp.items : []
            //         })
            //         setIsLoading(false)
            //         handleClose()
            //     } else {
            //         setPageError({error: true, errorText: `An error occurred and the person could not be processed. If the problem persists, please contact ${CONTACT_SUPPORT_LINK}.`})
            //     }
            //     setIsLoading(false)
            // }).catch(() => {
            //     setIsLoading(false)
            //     setPageError({error: true, errorText: `An error occurred and the person could not be processed. If the problem persists, please contact ${CONTACT_SUPPORT_LINK}.`})
            // })
        }
    };
    const isValid = () => {
        return reason !== ' ' && description.trim() !== '';
    };
    const changeReason = (event) => {
        setReason(event.target.options[event.target.selectedIndex].id);
    };
    const changeDescr = (event) => {
        setDescription(event.target.value);
    };
    const defaultButtonData = [
        { icon: '', text: 'Submit', type: hui_1.ButtonType.Primary, onClick: () => { submitAndClose(); }, state: isValid() ? hui_1.ButtonState.Enabled : hui_1.ButtonState.Disabled },
        { icon: '', text: 'Cancel', type: hui_1.ButtonType.Secondary | hui_1.ButtonType.Ghost, onClick: () => { handleClose(); }, state: hui_1.ButtonState.Enabled },
    ];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.TextNaked, icon: "pause-circle", text: "Put on Hold", onClick: handleShow }), (0, jsx_runtime_1.jsx)(hui_1.Drawer, { contentAriaLabel: `Add Medical Hold for ${person.name}`, show: show, onClose: handleClose, size: hui_1.DrawerSize.Medium, type: hui_1.DrawerType.Right, themedColor: "medical", header: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: `Put ${person.name} On Hold`, type: hui_1.TextType.Heading3 }) }), contents: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(react_loader_1.default, Object.assign({ loaded: !isLoading, options: Object.assign(Object.assign({}, Defaults_1.mediumLoaderOptions), { color: '#000000' }) }, { children: [pageError.error && (0, jsx_runtime_1.jsx)(react_bootstrap_1.Alert, Object.assign({ variant: 'danger' }, { children: pageError.errorText })), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Row, { children: (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Col, Object.assign({ xs: 6 }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'symptoms-question-heading' }, { children: "Reason" })), (0, jsx_runtime_1.jsx)("select", Object.assign({ className: 'form-control', onChange: changeReason }, { children: reasons.map((item) => ((0, jsx_runtime_1.jsx)("option", Object.assign({ id: item.id }, { children: item.text }), item.id))) })), reason !== ' ' && (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'symptoms-question-heading smallMarginTop' }, { children: "Comment" })), (0, jsx_runtime_1.jsx)("textarea", { rows: 3, className: 'form-control', value: description, onChange: changeDescr })] })] })) })] })) }), footer: defaultButtonData })] }));
};
const AddHold = (0, mobx_react_1.inject)('peopleStore', 'holds')((0, mobx_react_1.observer)(AddHoldComponent));
exports.default = AddHold;
